import { Action, createReducer, on } from '@ngrx/store';
import { fetchBlogsList, fetchBlogsListSuccess, fetchBlogsListFailure, fetchBlogsDetail, fetchBlogsDetailSuccess, fetchBlogsDetailFailure, deleteBlogFailure, deleteBlogSuccess } from './blogs.action';


export interface BlogsState {
  list: any[];
  detail:any;
  loading: boolean;
  error: any;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export const initialState: BlogsState = {
  list: [],
  detail: null,
  loading: false,
  error: null,
  pageNumber: 1,
  pageSize: 10,
  totalPages: 100,
  totalRecords: 100,
};

export const BlogsReducer = createReducer(
  initialState,
  on(fetchBlogsList, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchBlogsListSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      list: response.result,
      pageNumber: response.pageNumber,
      pageSize: response.pageSize,
      totalPages: response.totalPages,
      totalRecords: response.totalRecords,
    };
  }),
  on(fetchBlogsListFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),

  on(fetchBlogsDetail, (state) => {
    return { ...state, loading: true, error: null };
  }),
  on(fetchBlogsDetailSuccess, (state, { response }) => {
    return {
      ...state,
      loading: false,
      detail: response
    };
  }),
  on(fetchBlogsDetailFailure, (state, { error }) => {
    return { ...state, error, loading: false };
  }),
);

// Selector
export function reducer(state: BlogsState | undefined, action: Action) {
  return BlogsReducer(state, action);
}
